import styled from 'styled-components';

export const Container = styled.div<{
  typeIcon?: 'checked' | 'unchecked';
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: ${(p) =>
      // eslint-disable-next-line no-nested-ternary
      p.typeIcon === 'checked'
        ? '#35ba83'
        : p.typeIcon === 'unchecked'
        ? '#F64444'
        : '#F1F2F4'};
    width: 40px;
    min-width: 40px;
    height: 40px;
  }

  .info {
    display: flex;
    flex-direction: column;

    p:nth-child(1) {
      white-space: nowrap;
      font-size: 14px;
      font-weight: 600;
      color: ${(p) => (p.typeIcon ? '#000000' : '#C4C4C4')};
    }

    p:nth-child(2) {
      white-space: nowrap;
      display: ${(p) => (p.typeIcon ? 'initial' : 'none')};
      font-size: 11px;
      font-weight: 400;
      color: #7c8db5;
    }
  }
`;
